// Dependencies
import React, { useEffect, useState } from 'react';
import Stepper from "react-stepper-horizontal";
import { useIntl } from "react-intl";
import { Row } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { actions as actionStep,  getStep } from '../../../reducers/Step';
import { getTypePay } from '../../../reducers/TypePayment';
import StepOne from './step_one';
import StepTwo from './step_two';
import StepThree from './step_three';
import StepFour from './step_four';
import StepThreeLoan from './step_three_loan';

const Steps = () => {
    const intl = useIntl();
    const distpatch = useDispatch();
    const [step, setStep] = useState();
    const reduxStep = useSelector(getStep);
    const [dataPay, setDataPay] = useState(null);
    const type_pay = useSelector(getTypePay);

    const titles = [
        { title: intl.formatMessage({ id: "step.title.short.one" }) },
        { title: intl.formatMessage({ id: "step.title.short.two" }) },
        { title: intl.formatMessage({ id: "step.title.short.three" }) },
        { title: intl.formatMessage({ id: "step.title.short.four" }) }
    ];

    useEffect(() => {
        setStep(reduxStep)
    }, [reduxStep]);

    const handleSubmit = (response) => {
        let aux = [...response];
        setDataPay(aux);
        distpatch(actionStep.nextPage());
    }

    return (
        <>
            <Stepper steps={titles} activeStep={step}/>
            <Row className='mt-4 mb-4'>
                {step === 0 && <StepOne />}
                {step === 1 && <StepTwo />}
                {step === 2 && <StepThree handleSubmit={handleSubmit} />}
                {step === 3 && <StepFour datapay={dataPay}/>}
            </Row>
        </>
    );
}

export default Steps;